









import Vue, { PropType } from 'vue'
import CheckBoxesAgrupadosSecoes from 'src/typescript/common/CheckBoxes/CheckBoxesAgrupadosSecoes'
import { formatarOpcoesCheckBoxesAgrupados } from 'src/typescript/common/CheckBoxes/utils'

import {
  DCategoriaDePermissao,
  EventoObservavel,
  ICheckBoxesAgrupadosSecao,
  ICheckBoxesAgrupadosSecoes
} from 'src/tipos'

interface OpcoesPorPermissao {
  empregado: ICheckBoxesAgrupadosSecoes;
  gestor: ICheckBoxesAgrupadosSecoes;
}

interface Data {
  carregando: boolean;
  opcoesFormatadas: ICheckBoxesAgrupadosSecoes;
}

interface Methods {
  configurar: () => void;
  filtrarOpcoesPelaPermissao: () => ICheckBoxesAgrupadosSecoes;
  formatarOpcoes: (
    eventosObservados: EventoObservavel[],
    opcoesIniciais: ICheckBoxesAgrupadosSecoes
  ) => ICheckBoxesAgrupadosSecoes;
}

interface Computed {
  valueInterno: EventoObservavel[];
}

interface Props {
  value: EventoObservavel[];
  permissao: DCategoriaDePermissao;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'EventosObservados',

  components: {CheckBoxesAgrupadosSecoes},

  props: {
    value: {
      type: Array as PropType<EventoObservavel[]>,
      required: true
    },

    permissao: {
      type: String as PropType<DCategoriaDePermissao>,
      required: true
    }
  },

  computed: {
    valueInterno: {
      get (): EventoObservavel[] {
        return this.value
      },
      set (valueInternoAtualizado: EventoObservavel[]): void {
        this.$emit('input', valueInternoAtualizado)
      }
    }
  },

  data () {
    return {
      carregando: true,
      opcoesFormatadas: {} as ICheckBoxesAgrupadosSecoes
    }
  },

  mounted (): void {
    this.configurar()
  },

  watch: {
    permissao (permissaoNova: DCategoriaDePermissao, permissaoAntes: DCategoriaDePermissao): void {
      if (permissaoNova !== permissaoAntes) {
        this.configurar()
      }
    }
  },

  methods: {
    configurar (): void {
      const opcoesFiltradas = this.filtrarOpcoesPelaPermissao()
      const eventosObservados = this.valueInterno
      this.opcoesFormatadas = this.formatarOpcoes(eventosObservados, opcoesFiltradas)
    },

    filtrarOpcoesPelaPermissao (): ICheckBoxesAgrupadosSecoes {
      const opcoesGestor = {
        controleDeEntrada: {
          legenda: 'Sobre controle de entrada',
          opcoes: {
            'EntradaAdiantada': {
              valor: false,
              legenda: 'Entrada adiantada',
              type: 'relogio'
            },
            'IniciouAtraso': {
              valor: false,
              legenda: 'Iniciou atraso'
            },
            'EntradaNoHorario': {
              valor: false,
              legenda: 'Entrada no horário'
            },
            'EntradaAtrasada': {
              valor: false,
              legenda: 'Entrada atrasada'
            }
          }
        },
        controleDeSaida: {
          legenda: 'Sobre controle de saída',
          opcoes: {
            'SaidaAdiantada': {
              valor: false,
              legenda: 'Saída adiantada'
            },
            'SaidaNoHorario': {
              valor: false,
              legenda: 'Saída no horário'
            },
            'SaidaAtrasadaComHoraExtra': {
              valor: false,
              legenda: 'Saída atrasada com hora extra'
            },
            'IniciouHoraExtra': {
              valor: false,
              legenda: 'Iniciou hora extra'
            }
          }
        },
        controleDePausa: {
          legenda: 'Sobre controle de pausa',
          opcoes: {
            'PausaIniciada': {
              valor: false,
              legenda: 'Pausa iniciada'
            },
            'RetornoAdiantado': {
              valor: false,
              legenda: 'Retorno adiantado'
            },
            'RetornoNoHorario': {
              valor: false,
              legenda: 'Retorno no horário'
            },
            'RetornoAtrasado': {
              valor: false,
              legenda: 'Retorno atrasado'
            },
            'IniciouAtrasoDoRetornoDaPausa': {
              valor: false,
              legenda: 'Iniciou atraso do retorno de pausa'
            }
          }
        }
      } as ICheckBoxesAgrupadosSecoes

      const opcoesFuncionario = {
        lembreteDePonto: {
          legenda: 'Lembrete de ponto',
          opcoes: {
            // 'HorarioDeEntradaProximo': {
            //   valor: false,
            //   legenda: 'Horário de entrada próximo'
            // },
            'ChegouHorarioDeEntrada': {
              valor: false,
              legenda: 'Chegou horário de entrada'
            },
            'HorarioDeSaidaProximo': {
              valor: false,
              legenda: 'Horário de saída próximo'
            },
            'ChegouHorarioDeSaida': {
              valor: false,
              legenda: 'Chegou hora de saída'
            },
            'IniciouHoraExtra': {
              valor: false,
              legenda: 'Iniciou hora extra'
            },
            'ChegouHorarioDeRetornoDaPausa': {
              valor: false,
              legenda: 'Chegou hora de retorno da pausa'
            }
          }
        }
      } as ICheckBoxesAgrupadosSecoes

      const opcoesPorTipoObservado = {
        empregado: opcoesFuncionario,
        gestor: opcoesGestor
      } as OpcoesPorPermissao

      const opcoesIniciais = opcoesPorTipoObservado[this.permissao]
      return opcoesIniciais
    },

    formatarOpcoes (
      eventosObservados: EventoObservavel[],
      opcoesIniciais: ICheckBoxesAgrupadosSecoes
    ): ICheckBoxesAgrupadosSecoes {
      function formatarSecoesOpcoesCheckBoxes (
        listaDeOpcoesSelecionada: Array<string>,
        opcoesIniciais: ICheckBoxesAgrupadosSecoes
      ): ICheckBoxesAgrupadosSecoes {
        const opcoesFormatadas = Object.entries(opcoesIniciais).reduce((
          acumulador: ICheckBoxesAgrupadosSecoes,
          opcaoAtual: [string, ICheckBoxesAgrupadosSecao]
        ) => {
          const [chave, configuracao] = opcaoAtual
          acumulador[chave] = configuracao
          acumulador[chave].opcoes = formatarOpcoesCheckBoxesAgrupados(listaDeOpcoesSelecionada, configuracao.opcoes)
          return acumulador
        }, {} as ICheckBoxesAgrupadosSecoes)
        return opcoesFormatadas
      }

      const opcoesFormatadas = formatarSecoesOpcoesCheckBoxes(eventosObservados, opcoesIniciais)
      return opcoesFormatadas
    }
  }
})
